"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Trigger a plugin event
 * @param core The EditorCore object
 * @param pluginEvent The event object to trigger
 * @param broadcast Set to true to skip the shouldHandleEventExclusively check
 */
exports.triggerEvent = function (core, pluginEvent, broadcast) {
    if (broadcast ||
        !core.eventHandlerPlugins.some(function (plugin) { return handledExclusively(pluginEvent, plugin); })) {
        core.eventHandlerPlugins.forEach(function (plugin) {
            if (plugin.onPluginEvent) {
                plugin.onPluginEvent(pluginEvent);
            }
        });
    }
};
function handledExclusively(event, plugin) {
    if (plugin.onPluginEvent &&
        plugin.willHandleEventExclusively &&
        plugin.willHandleEventExclusively(event)) {
        plugin.onPluginEvent(event);
        return true;
    }
    return false;
}
//# sourceMappingURL=triggerEvent.js.map